import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
export const usePedidosNavegacao = () => {
  const history = useHistory();
  const handleRowClick = useCallback(row => {
    console.log('🖱️ Clicou na linha:', row);
    history.push(`/pages/pedidos/detalhes/${row.id}`);
  }, [history]);
  const handleAdicionar = useCallback(() => {
    console.log('➕ Botão adicionar clicado');
    history.push('/pages/pedidos/criar');
  }, [history]);
  const handleEditar = useCallback(id => {
    console.log('✏️ Editando pedido:', id);
    history.push(`/pages/pedidos/editar/${id}`);
  }, [history]);
  return {
    handleRowClick,
    handleAdicionar,
    handleEditar
  };
};
